@import '~style-sheet-helpers/core.less';

.page-wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  position: relative;
  .toggle-icon {
    top: 14px;
  }
}

.leftnav {
  > :first-child {
    overflow-y: auto;
  }
}

.loading {
  width: 100%;
  height: 100%;
}

.page {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
  height: 100%;

  h1 {
    padding: 24px 0;
    margin: 0 0 24px;
  }

  h1,
  h3 {
    font-weight: @normal;
  }

  h3 {
    font-size: 20px;
    font-weight: @normal;
    margin: 16px 0;
  }
}
